import React from "react";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const DisclosureSection = ({ title, content }) => (
  <Disclosure>
    {({ open }) => (
      <>
        <DisclosureButton className="mt-6 flex items-center gap-2 text-primary">
          <ChevronDownIcon
            className={`w-4 h-4 transition-transform ${open ? "rotate-180 transform" : ""}`}
          />
          <span className="underline">{title}</span>
        </DisclosureButton>
        <DisclosurePanel className="mt-4">
          <div className="space-y-4">{content}</div>
        </DisclosurePanel>
      </>
    )}
  </Disclosure>
);

export default DisclosureSection;